import {nombreDeAcciones} from 'constantes/index';
const mapDispatchToProps = dispatch => ({
    LOGOUT: ()=> dispatch({ "type":nombreDeAcciones.LOGOUT,"state":{} }),
    SET_MENU: (menu)=> dispatch({  "type":nombreDeAcciones.SET_MENU, "state":{"menu":menu, }}),
});
export default mapDispatchToProps;